import { render, staticRenderFns } from "./MomentStoryDetail.vue?vue&type=template&id=402caf0e&scoped=true&"
import script from "./MomentStoryDetail.vue?vue&type=script&lang=js&"
export * from "./MomentStoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./MomentStoryDetail.vue?vue&type=style&index=0&id=402caf0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402caf0e",
  null
  
)

export default component.exports